import gql from 'graphql-tag';

export const getVisitorPassUpdateOperationStatus = gql(/* GraphQL */ `
  query getVisitorPassUpdateOperationStatus($operationId: String!, $channelId: String!) {
    getVisitorPassUpdateOperationStatus(operationId: $operationId, channelId: $channelId) {
      results {
        visitorPassId
        success
        errorMessage
      }
      status
    }
  }
`);

